import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from '@mui/material'
import PropTypes from 'prop-types'

const dialogText = {
  Active: {
    title: 'Request Serivce Resumption',
    content: (
      <>
        This SIM will be resumed from the start of the next bill cycle.
        <br /> <br />
        The monthly subscription will resume from the next bill cycle onwards.
      </>
    ),
    proceedButton: 'Activate'
  },
  Suspended: {
    title: 'Request Temporary Suspension',
    content: (
      <>
        This SIM will be temporary suspended from the start of the next bill
        cycle.
        <br /> <br />
        To resume the SIM, please change status to “Resume”.
      </>
    ),
    proceedButton: 'Suspend'
  },
  Terminated: {
    title: 'Request Service Termination',
    content: (
      <>
        This SIM will be terminated at the end of this bill cycle.
        <br /> <br />
        The Number will no longer be available after termination.
      </>
    ),
    proceedButton: 'Terminate'
  }
}

function AlertDialog({
  teamMember,
  isDialogOpen,
  setDialogOpen,
  handleSaveChanges,
  simStatus
}) {
  return (
    <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
      <DialogTitle variant='h4' id='alert-dialog-title'>
        {dialogText[simStatus || teamMember?.status || 'Suspended'].title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <Typography variant='subtitle1' sx={{ marginBottom: '24px' }}>
            {
              dialogText[simStatus || teamMember?.status || 'Suspended']
                .content
            }
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDialogOpen(false)} autoFocus>
          Cancel
        </Button>
        <Button onClick={handleSaveChanges}>
          Proceed to
          {
            dialogText[simStatus || teamMember?.status || 'Suspended']
              .proceedButton
          }
        </Button>
      </DialogActions>
    </Dialog>
  )
}

AlertDialog.propTypes = {
  teamMember: PropTypes.object,
  isDialogOpen: PropTypes.bool,
  setDialogOpen: PropTypes.func,
  handleSaveChanges: PropTypes.func,
  simStatus: PropTypes.string
}

export default AlertDialog
